import { render } from "./ActivityData.vue?vue&type=template&id=83ebf456&scoped=true"
import script from "./ActivityData.vue?vue&type=script&lang=js"
export * from "./ActivityData.vue?vue&type=script&lang=js"

import "./ActivityData.vue?vue&type=style&index=0&id=83ebf456&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83ebf456"]])

export default __exports__